import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./DisciplineEditDetails.module.css";
import InputCharLimit from "../../../UI/Inputs/InputCharLimit/InputCharLimit";
import { HexagonalColorPicker } from "react-hexagon-color-picker";
import Select from "../../../UI/Selects/Select";
import { CourseTypeEnum, CourseTypeEnumText } from "../../../../models/CourseTypeEnum";
import { getClassByNum, toCApi } from "../../../../utils";
import BtnSelect from "../../../UI/Buttons/BtnSelect"
import Curriculum from "../../Curriculums/Curriculum";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { coursesApi } from "../../../../utils";
import CourseDurationOptions from "../../../../models/CourseDurationOptions";
import SwitchToggle from "../../../UI/SwitchToggle";
import Modal from "../../../UI/Modal";
import CurriculumCard from "../../Curriculums/CurriculumCard";
import { RadioInput, RadioOption } from "../../../UI/Inputs/InputRadio/RadioBtns";
import { disciplineAction } from "../../../../store/discipline-slice";

const DisciplineEditDetails = ({ id, handleChangeCourseDate, courseData }) => {

    const { lang, texts } = useSelector(state => state.translate);
    const years = useSelector(state => state.studyYears.years);
    const [inputsValue, setInputsValue] = useState({})
    const [popupPage, setPopupPage] = useState();
    const [popupCard, setPopupCard] = useState();
    const [requeriedMessage, setRequeriedMessage] = useState();
    const applicationId = useSelector(state => state.application.applicationId);
    const dispatch = useDispatch();
    const componentMounted = useRef(true);


    useEffect(() => {
        const additionalData = JSON.parse(courseData.additionalData ? courseData.additionalData : "{}");

        setInputsValue({
            ...courseData,
            urlCardBackgroundImage: additionalData.CardBackgroundImage && `${courseData.baseUrl}/${additionalData.CardBackgroundImage}`,
            nameCardBackgroundImage: additionalData.CardBackgroundImage && "image.jpg",
            urlPageBackgroundImage: additionalData.PageBackgroundImage && `${courseData.baseUrl}/${additionalData.PageBackgroundImage}`,
            namePageBackgroundImage: additionalData.PageBackgroundImage && "image.jpg",

            ...additionalData
        })

    }, [id, courseData])

    const handelsave = () => {
        const data = {
            id: courseData.id,
            name: inputsValue.name,
            description: inputsValue.description,
            fullDescription: inputsValue.fullDescription,
            year: inputsValue.year,
            lang: inputsValue.lang,
            active: inputsValue.active,
            applicationId: applicationId,
            fromClass: parseInt(inputsValue.fromClass, 10),
            toClass: parseInt(inputsValue.toClass, 10),
            recommendedClass: parseInt(inputsValue.recommendedClass, 10),
            duration: parseInt(inputsValue.duration, 10),
            courseType: inputsValue.courseType
        };

        const requeriedInputs = ["courseType", "fromClass", "recommendedClass", "toClass", "lang", "name", "duration"]
        if (requeriedInputs.some(r => !data[r] || data[r] === "false") || (!inputsValue.BaseColor || inputsValue.BaseColor === false)) {
            setRequeriedMessage(texts.errorValidationForm)
        }
        else {
            if (courseData.id) {
                // to do check
                coursesApi.coursesUpdatePost({ courseAddOrUpdateInput: data }, async (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
                    } else {
                        if (componentMounted.current) {
                            await handleChangeAdditionalData(courseData.id)
                            handleChangeCourseDate({ ...resdata });
                        }
                    }
                })
            }
            else {
                // to do check
                const parentTopicsNames = [texts.generalLessons, texts.enrichmenLessons, texts.contestsLessons];
                coursesApi.coursesAddPost({ courseAddOrUpdateInput: data }, async (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
                    } else {
                        if (componentMounted.current) {
                            await handleChangeAdditionalData(resdata.id, true);
                            let prevId = null
                            for (let i = 0; i < 3; i++) {

                                prevId = await addParentTopic(resdata.id, parentTopicsNames[i], prevId)
                            }
                            handleChangeCourseDate({ ...resdata });
                        }
                    }
                })
            }
        }
    }

    const addParentTopic = (id, name, prevId) => new Promise((resolve) => {
        const data = {
            courseId: id,
            parentId: null,
            name: name,
            active: true,
            visible: true,
            prevId: prevId
        }

        toCApi.toCAddPost({ toCAddInput: data }, (error, resdata, response) => {
            if (error) {
                console.log("error", error)
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCAddPost " + error.message, level: 1, component: "CoursesPage", line: 106 }))
            }
            else {
                if (componentMounted.current) {
                    resolve(resdata)
                }
            }
        })
    })

    const handleChangeAdditionalData = (id, newCourse) => new Promise((resolve) => {

        const dataAdditionalData = {
            id: id,
            cardBackgroundImage: inputsValue.CardBackgroundImage,
            baseColor: inputsValue.BaseColor,
            pageBackgroundImage: inputsValue.PageBackgroundImage
        }

        coursesApi.coursesUpdateAdditionalDataPost(dataAdditionalData, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    if (newCourse)
                        dispatch(disciplineAction.add(resdata))
                    else
                        dispatch(disciplineAction.update(resdata))
                    resolve();
                }
            }
        })
    })

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    const handleChangeValue = (name, v) => {
        setInputsValue(prevInputsValue => ({ ...prevInputsValue, [name]: v }))
    }

    const handleFileUpload = (e, name) => {
        if (e.target.files && e.target.files[0])
            setInputsValue(prevInputsValue => ({ ...prevInputsValue, [name]: e.target.files[0], [`url${name}`]: URL.createObjectURL(e.target.files[0]), [`name${name}`]: e.target.files[0].name }))
    }

    const handleCheckedChange = (func) => {
        setInputsValue(prevInputsValue => ({ ...prevInputsValue, "active": func(prevInputsValue.active) }))
    }


    const GradesArr = [...Array(12)].map((x, i) => ({ text: getClassByNum(i + 1), value: i + 1 }))

    return <div className={classes.DisciplineEditDetails}>
        <div className={`${classes.Part}`}>
            <div className={classes.Flex}>
                <div className={classes.CourseName}>
                    <InputCharLimit value={inputsValue.name} type={"input"} label={texts.courseName} name={"name"} limitNum={30} setValue={handleChangeValue} ></InputCharLimit>
                </div>
                <div className={classes.SwitchToggleActive}>
                    <div className={`${classes.Flex} ${classes.FlexCenter}`}>
                        <div className={classes.Label}>{texts.active}</div>
                        <SwitchToggle id={"active"} checked={inputsValue.active} setChecked={handleCheckedChange}></SwitchToggle>
                    </div>
                </div>
            </div>
            <div >
                <div className={classes.Flex}>
                    <div className={classes.SelectLang}>
                        <div className={classes.Label}>{texts.selectLang}</div>
                        <RadioInput onChangeValue={handleChangeValue} value={inputsValue.lang} name={"lang"}>
                            <RadioOption value={"he"}>{texts.he}</RadioOption>
                            <RadioOption value={"ar"}>{texts.ar}</RadioOption>
                        </RadioInput>

                    </div>
                    <div className={classes.SelectColor}>
                        <div className={classes.Label}>{texts.selectBaseColor}</div>
                        <div className={classes.SelectColorDiv} style={{ backgroundColor: inputsValue.BaseColor }}></div>
                        <div className={classes.SelectColorPicker}><HexagonalColorPicker color={inputsValue.BaseColor} onColorChange={(color) => handleChangeValue("BaseColor", color)}></HexagonalColorPicker></div>
                    </div>

                </div>
                <div className={classes.Label}>{texts.selectYear}</div>
                <Select name={"year"} setValue={(name, value) => handleChangeValue(name, parseInt(value, 10))} value={[inputsValue?.year]} options={Object.keys(years).reduce((acc, year) => { acc.push({ text: years[year][lang], value: year }); return acc; }, [])}></Select>
            </div>
            <div className={classes.Details}>
                <div className={classes.Label}>{texts.data}:</div>
                <div className={classes.SelectsWrap}>
                    <Select label={texts.couresType} name={"courseType"} setValue={handleChangeValue} value={CourseTypeEnumText[inputsValue.courseType]} options={Object.keys(CourseTypeEnumText).reduce((options, key) => options.concat([{ text: texts[key], value: CourseTypeEnumText[key] }]), [])}></Select>
                    <Select label={texts.courseTime} name={"duration"} setValue={handleChangeValue} value={inputsValue.duration} options={Object.keys(CourseDurationOptions).reduce((options, key) => options.concat([{ text: texts[key], value: CourseDurationOptions[key] }]), [])}></Select>
                    <Select label={texts.gradeLearn} name={"recommendedClass"} setValue={handleChangeValue} value={inputsValue.recommendedClass} options={GradesArr}></Select>
                    <Select label={texts.fromClass} name={"fromClass"} setValue={handleChangeValue} value={inputsValue.fromClass} options={GradesArr}></Select>
                    <Select label={texts.suitableUpToGrade} name={"toClass"} setValue={handleChangeValue} value={inputsValue.toClass} options={GradesArr}></Select>
                </div>
            </div>
            {requeriedMessage && <div className={classes.ErrorValidation}>* {requeriedMessage}</div>}
        </div>
        <div className={classes.Part}>
            <div className={classes.Title}>{texts.editCurriculumPage}</div>
            <div className={classes.bgImage}>
                <div className={classes.Label}>{texts.uploadCourseBgImage} &emsp;&emsp;&emsp; 1020px x 133px </div>
                <div className={classes.HeaderInput}>
                    <input type={'file'} name="PageBackgroundImage" onChange={(e) => handleFileUpload(e, "PageBackgroundImage")} accept={"image"} className={classes.InputFile}></input>
                    <div className={classes.FileName}>{inputsValue.namePageBackgroundImage}</div>
                    <span className={classes.BeforeInputFile}>{texts.chooseFile}</span>
                </div>
            </div>
            <div className={classes.CourseLongDescription}>
                <InputCharLimit value={inputsValue.fullDescription} type={"textarea"} label={texts.descCourse} dropClass={classes.InputFullDescription} name={"fullDescription"} limitNum={600} setValue={handleChangeValue} ></InputCharLimit>
            </div>

            <BtnSelect dropClass={classes.Btn} onClick={() => setPopupPage(true)}>{texts.pagePreview}</BtnSelect>
            {popupPage && <Modal dropClass={classes.ModelPopupPage} onClose={() => setPopupPage(false)}>
                <div className={classes.CurriculumWrap}> <Curriculum data={{ ...inputsValue, pageBackgroundImage: inputsValue.urlPageBackgroundImage }}></Curriculum></div>
            </Modal>}
        </div>
        <div className={classes.Part}>
            <div className={classes.Title}>{texts.editCard}</div>
            <div className={classes.bgImage}>
                <div className={classes.Label}>{texts.uploadCardBGCourseImage} &emsp;&emsp;&emsp;&emsp; 232px x 73px </div>
                <div className={classes.HeaderInput}>
                    <input type={'file'} name="CardBackgroundImage" onChange={(e) => handleFileUpload(e, "CardBackgroundImage")} accept={"image"} className={classes.InputFile}></input>
                    <div className={classes.FileName}>{inputsValue.nameCardBackgroundImage}</div>
                    <span className={classes.BeforeInputFile}>{texts.chooseFile}</span>
                </div>
            </div>
            <div className={classes.CourseSummaryDiscription}>
                <InputCharLimit value={inputsValue.description} type={"textarea"} label={texts.summaryDiscription} style={{ width: "549px", height: "127px" }} name={"description"} limitNum={200} setValue={handleChangeValue} ></InputCharLimit>
            </div>
            <BtnSelect dropClass={classes.Btn} onClick={() => setPopupCard(true)}>{texts.courseCardPreview}</BtnSelect>
            {popupCard && <Modal dropClass={classes.ModelPopupCard} onClose={() => setPopupCard(false)}>
                <CurriculumCard {...inputsValue} backgroundImage={inputsValue.urlCardBackgroundImage}></CurriculumCard>
            </Modal>}
        </div>
        <BtnSelect dropClass={classes.Btn} checked={true} onClick={handelsave}>{texts.saveChange}</BtnSelect>
    </div>

}

export default DisciplineEditDetails;